import { render, staticRenderFns } from "./ProductSlider.vue?vue&type=template&id=0c998f24"
import script from "./ProductSlider.vue?vue&type=script&lang=ts"
export * from "./ProductSlider.vue?vue&type=script&lang=ts"
import style0 from "./ProductSlider.vue?vue&type=style&index=0&id=0c998f24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports